import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import "./AllocateMenu.css";
function AllocateMenu({ validateAllotment, allUsers }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const [allocatedUser, setAllocatedUser] = useState("");

  const getUserName = (user) => {
    return user.emailId.split("@")[0];
  };
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        variant="contained"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Allocate
      </Button>
      <Menu
        PaperProps={{ sx: { position: "absolute", maxHeight: "300px" } }}
        className="menu-container"
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {allUsers.map((user, index) => {
          if (!user.isTechTeam)
            return (
              <MenuItem
                key={index}
                style={{ justifyContent: "center" }}
                selected={allocatedUser === getUserName(user) ? true : false}
                onClick={(e) => {
                  setAllocatedUser(getUserName(user));
                }}
              >
                {
                  <div>
                    <div className="login-status">
                      <span
                        className={user.isloggedIn ? "logged-in" : "logged-out"}
                      >
                        ●
                      </span>
                    </div>
                    <div className="user-name">{getUserName(user)}</div>
                  </div>
                }
              </MenuItem>
            );
        })}
        <div className="footer">
          <Button
            variant="contained"
            onClick={() => validateAllotment(allocatedUser)}
          >
            Allocate
          </Button>
        </div>
      </Menu>
    </div>
  );
}

export default AllocateMenu;
